import React from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import Plus from '../../img/svgComponents/Plus'
import Utils from '../../core/Utils'
import { useNavigate } from 'react-router-dom'
import { openModal } from '../../redux/slices/modalSlice'
import { ModalType } from '../../core/enums/Modals'
import { useTranslation } from '../../hooks/useTranslation'

const TabContentProfile = () => {
	const wallet = useAppSelector((state: RootState) => state.wallet)
	const profile = useAppSelector((state: RootState) => state.userPublic.profile)
	const levels = useAppSelector((state: RootState) => state.level.levels)
	const currentLevel = levels?.find((level) => level.id === profile?.ach_level_current_id)
	const isMobile = Utils.isMobile()
	const navigate = useNavigate()
	const dispatch = useAppDispatch()

	const { getTexts } = useTranslation(true)

	const handleDeposit = () => {
		if (isMobile) {
			navigate('/cashier')
		} else {
			dispatch(openModal({ modalType: ModalType.Cashier }))
		}
	}

	return (
		<div className="tab-content-profile">
			<div className="balances">
				<div className="balance-card main">
					<div className="balance-deposit" onClick={handleDeposit}>
						<Plus />
					</div>
					<div className="balance-card-icon"></div>
					<div className="balance-card-title">{getTexts('balance')}</div>
					<div className="balance-card-amount">
						<span>EUR</span>
						{wallet.balance.toFixed(2)}
					</div>
				</div>
				<div className="balance-card bonus">
					<div className="balance-card-icon"></div>
					<div className="balance-card-title">{getTexts('bonus_balance')}</div>
					<div className="balance-card-amount">
						<span>EUR</span> 124.03
					</div>
				</div>
				<div className="balance-card points">
					<div className="balance-card-icon"></div>
					<div className="balance-card-title">{getTexts('loyalty_points')}</div>
					<div className="balance-card-amount">{profile?.ach_points_balance}</div>
				</div>
			</div>

			<div className="benefits">
				<div className="benefits-title">{`${currentLevel?.name}'s Benefits`}</div>
				<div className="benefit-cards">
					<div className="benefit-card  casino">
						<div className="benefit-container">
							<div className="img"/>
							<div className="benefit-title">{getTexts('vip_free_spins')}</div>
							<div className="benefit-description">
								{getTexts('vip_free_spins_text')}
							</div>
						</div>
					</div>
					<div className="benefit-card sport">
						<div className="benefit-container ">
							<div className="img" />
							<div className="benefit-title">{getTexts('sports_weekly_bonus')}</div>
							<div className="benefit-description">{getTexts('sports_weekly_bonus_text')}</div>
						</div>
					</div>
					<div className="benefit-card beach ">
						<div className="benefit-container">
							<div className="img" />
							<div className="benefit-title">{getTexts('luxury_gifts')}</div>
							<div className="benefit-description">{getTexts('luxury_gifts_text')}</div>
						</div>
					</div>
					<div className="benefit-card cards">
						<div className="benefit-container">
							<div className="img" />
							<div className="benefit-title">{getTexts('exclusive_games')}</div>
							<div className="benefit-description">{getTexts('exclusive_games_text')}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default TabContentProfile
